import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Link, useNavigate } from 'react-router-dom';
import isObject from 'lodash/isObject';
import { Button, Card, Col, Row, Space } from 'antd';
import { RiArrowLeftLine } from 'react-icons/ri';
import urlPageCategories from '../../../../../urls/urlPageCategories';
import handleResponse from '../../../../../lib/handleResponse';
import transformErrors from '../../../../../lib/transformErrors';
import BreadCrumbs from '../../../../../layout/components/breadcrumbs';
import FormCreateCategory from '../../../forms/FormCreateCategory';
import IntlMessages from '../../../../../layout/components/lang/IntlMessages';
import { useCreateCategoryMutation } from '../../../api/categoriesApiSlice';



const PageCreateCategory = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const [ errors, setFormErrors ] = useState({});

  const [ createCategory, { isLoading: isCreatingCategory } ] = useCreateCategoryMutation();


  const handleSubmit = (values) => {
    createCategory({ values })
      .unwrap()
      .then(() => handleResponse(
        'success',
        intl,
        'ui-general-created-successfully',
        [ () => navigate(urlPageCategories()) ],
      ))
      .catch((error) => {
        handleResponse(
          'error',
          intl,
          'ui-general-create-failed',
          [ () => {
            if (isObject(error?.data?.errors)) {
              setFormErrors(transformErrors(error?.data?.errors));
            }
          } ],
          error,
        );
      });
  };

  const initialValues = {
    title: null,
    client_id: null,
    template_id: null,
    description: null,
    is_published: false,
    options: null,
    target: {
      min_version: null,
      max_version: null,
      platform: [],
      countries: [],
    },
    data: {},
  };

  return (
    <>
      <Row
        gutter={[ 32, 32 ]}
        justify="space-between"
        className="hp-mb-32"
        align="middle"
      >
        <BreadCrumbs
          breadCrumbParent={
            <Link to={urlPageCategories()}>
              <IntlMessages id="categories-breadcrumbs" />
            </Link>
          }
          breadCrumbActive={<IntlMessages id='ui-general-create' />}
        />

        <Col md={12} span={24}>
          <Row
            gutter={[ 8, 8 ]}
            justify="end"
            align="middle"
          >
            <Col>
              <Space>
                <Link to={urlPageCategories()}>
                  <Button
                    type="primary"
                    className="hp-mr-sm-8"
                    ghost="true"
                    icon={<RiArrowLeftLine className="hp-mr-8" size={18} />}
                  >
                    <IntlMessages id='ui-general-back-to-list' />
                  </Button>
                </Link>
              </Space>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[ 32, 32 ]}>
        <Col span={24}>
          <Card className="hp-border-color-black-40 hp-card-6">
            <FormCreateCategory
              initialErrors={errors}
              initialValues={initialValues}
              isSubmitting={isCreatingCategory}
              onSubmit={handleSubmit}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default PageCreateCategory;
